import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "refine__mobile--menu row" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 0,
  class: "mb-10"
}
const _hoisted_4 = { class: "refine__dealer-name" }
const _hoisted_5 = {
  key: 1,
  class: "row"
}
const _hoisted_6 = { class: "col-6-md mb-10" }
const _hoisted_7 = { class: "col-6-md mb-10" }
const _hoisted_8 = { class: "multiMakeModels mb-10" }
const _hoisted_9 = { class: "refine__models--dd" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "form__field form__field--dropdown"
}
const _hoisted_13 = {
  key: 2,
  class: "row"
}
const _hoisted_14 = { class: "col-6-md mb-10" }
const _hoisted_15 = { class: "col-6-md mb-10" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-6-md" }
const _hoisted_18 = { class: "col-6-md" }
const _hoisted_19 = { class: "col-12-sm" }
const _hoisted_20 = {
  key: 0,
  class: "alert"
}
const _hoisted_21 = {
  key: 4,
  class: "row"
}
const _hoisted_22 = { class: "col-6-md" }
const _hoisted_23 = { class: "col-6-md" }
const _hoisted_24 = { class: "col-12-sm" }
const _hoisted_25 = {
  key: 0,
  class: "alert"
}
const _hoisted_26 = {
  key: 5,
  class: "row"
}
const _hoisted_27 = { class: "col-12-sm" }
const _hoisted_28 = {
  key: 0,
  class: "mt-10"
}
const _hoisted_29 = { class: "refine__dealer-name" }
const _hoisted_30 = { class: "col-6-md pt-10" }
const _hoisted_31 = { class: "col-6-md pt-10" }
const _hoisted_32 = { class: "col-12-sm" }
const _hoisted_33 = {
  key: 0,
  class: "alert"
}
const _hoisted_34 = {
  key: 1,
  class: "alert"
}
const _hoisted_35 = {
  key: 0,
  class: "row"
}
const _hoisted_36 = { class: "col-6-md" }
const _hoisted_37 = { class: "col-6-md" }
const _hoisted_38 = { class: "col-12-sm" }
const _hoisted_39 = {
  key: 0,
  class: "alert"
}
const _hoisted_40 = {
  key: 1,
  class: "refine__header"
}
const _hoisted_41 = {
  class: "form__input d-flex mb-20",
  style: {"align-items":"center","justify-content":"flex-start"}
}
const _hoisted_42 = { style: {"height":"30px"} }
const _hoisted_43 = ["innerHTML"]
const _hoisted_44 = { class: "row" }
const _hoisted_45 = { class: "col-6-md" }
const _hoisted_46 = { class: "col-6-md" }
const _hoisted_47 = { class: "col-12-sm" }
const _hoisted_48 = {
  key: 0,
  class: "alert"
}
const _hoisted_49 = {
  class: "form__input d-flex mb-20",
  style: {"align-items":"center","justify-content":"flex-start"}
}
const _hoisted_50 = { style: {"height":"30px"} }
const _hoisted_51 = {
  class: "form__input d-flex mb-20",
  style: {"align-items":"center","justify-content":"flex-start"}
}
const _hoisted_52 = { style: {"height":"30px"} }
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "col-12-sm" }
const _hoisted_55 = ["disabled"]
const _hoisted_56 = { class: "col-12-sm" }
const _hoisted_57 = { class: "col-12-sm" }
const _hoisted_58 = {
  key: 0,
  class: "col-12-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_multi_select = _resolveComponent("multi-select")!
  const _component_drop_down = _resolveComponent("drop-down")!
  const _component_input_text = _resolveComponent("input-text")!
  const _component_slider = _resolveComponent("slider")!
  const _component_keywords = _resolveComponent("keywords")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass({'mobile__refine--button': true, 'mobile__refine--selected': _ctx.mobileRefineOpened}),
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.mobileRefineToggle && _ctx.mobileRefineToggle(...args)), ["prevent"]))
      }, [
        _cache[36] || (_cache[36] = _createElementVNode("i", { class: "fi-filter" }, null, -1 /* CACHED */)),
        _createElementVNode("span", {
          class: "mob__refine-text",
          innerHTML: _ctx.mobileRefineOpened ? 'Close' : 'Refine'
        }, null, 8 /* PROPS */, _hoisted_2)
      ], 2 /* CLASS */)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass({'mobile__refine': true, 'mobile__refine--hidden': !_ctx.mobileRefineOpened})
    }, [
      _cache[61] || (_cache[61] = _createElementVNode("div", { class: "clear mobile__refine--spacer" }, null, -1 /* CACHED */)),
      (_ctx.dealerName)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[37] || (_cache[37] = _createElementVNode("div", { class: "refine__header mb-10" }, " Dealer stock for ", -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("i", {
                class: "fi-cancel text-red pointer",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.removeDealerFilter && _ctx.removeDealerFilter(...args)))
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.dealerName), 1 /* TEXT */)
            ])
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.cars === 'used')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _cache[38] || (_cache[38] = _createElementVNode("div", { class: "col-12-sm" }, [
              _createElementVNode("div", { class: "refine__header mb-10" }, " New and used cars ")
            ], -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                class: _normalizeClass({
                        'button': true,
                        'button--small': true,
                        'button--full': true,
                        'button--ghost': _ctx.cars !== 'used'
                    }),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeCarType('used')))
              }, " Used ", 2 /* CLASS */)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("a", {
                href: "/leasing",
                class: _normalizeClass({
                        'button': true,
                        'button--small': true,
                        'button--full': true,
                        'button--ghost': _ctx.cars === 'used'
                    })
              }, " New ", 2 /* CLASS */)
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _cache[62] || (_cache[62] = _createElementVNode("div", { class: "refine__header mb-10" }, " Make & Model ", -1 /* CACHED */)),
      _createVNode(_component_multi_select, {
        modelValue: _ctx.searchObject.makes,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchObject.makes) = $event)),
        name: "make",
        options: _ctx.searchOptions.makes,
        placeholder: "Preferred Manufacturers",
        loading: _ctx.makesUpdating,
        searchable: true,
        onChange: _ctx.changeMake
      }, null, 8 /* PROPS */, ["modelValue", "options", "loading", "onChange"]),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchObject.makes, (make) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", {
              class: "refine__header refine__header--models",
              innerHTML: make.toUpperCase() + ' Models'
            }, null, 8 /* PROPS */, _hoisted_10),
            (_ctx.searchOptions.models[make] && _ctx.searchOptions.models[make].length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_multi_select, {
                    modelValue: _ctx.searchObject.models[make],
                    "onUpdate:modelValue": ($event: any) => ((_ctx.searchObject.models[make]) = $event),
                    name: make+'models',
                    options: _ctx.searchOptions.models[make],
                    placeholder: "Preferred Models",
                    searchable: true,
                    onChange: _ctx.updateCount
                  }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "name", "options", "onChange"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[39] || (_cache[39] = [
                  _createElementVNode("div", {
                    class: "loading",
                    style: {"height":"40px"}
                  }, [
                    _createElementVNode("div", { class: "buffer buffer--large buffer--rounded" })
                  ], -1 /* CACHED */)
                ]))]))
          ]))
        }), 256 /* UNKEYED_FRAGMENT */))
      ]),
      _cache[63] || (_cache[63] = _createElementVNode("div", { class: "refine__header" }, " Bodystyle ", -1 /* CACHED */)),
      _createVNode(_component_drop_down, {
        modelValue: _ctx.searchObject.bodystyle,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchObject.bodystyle) = $event)),
        name: "bodystyle",
        options: _ctx.searchOptions.bodystyle,
        onChange: _ctx.updateCount
      }, null, 8 /* PROPS */, ["modelValue", "options", "onChange"]),
      (_ctx.cars === 'used')
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", {
                class: _normalizeClass({
                            'button': true,
                            'button--small': true,
                            'button--full': true,
                            'button--ghost': _ctx.searchObject.pricetype !== 'cash'
                        }),
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changePriceType('cash')))
              }, " Cash Price ", 2 /* CLASS */)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", {
                class: _normalizeClass({
                            'button': true,
                            'button--small': true,
                            'button--full': true,
                            'button--ghost': _ctx.searchObject.pricetype !== 'finance'
                        }),
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changePriceType('finance')))
              }, " Monthly Price ", 2 /* CLASS */)
            ])
          ]))
        : _createCommentVNode("v-if", true),
      (['used', 'finance'].includes(_ctx.cars) && _ctx.searchObject.pricetype === 'cash')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_drop_down, {
                  modelValue: _ctx.searchObject.minprice,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.searchObject.minprice) = $event)),
                  name: "minprice",
                  options: _ctx.searchOptions.price,
                  onChange: _ctx.updateCount,
                  label: "Min Price"
                }, null, 8 /* PROPS */, ["modelValue", "options", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_drop_down, {
                  modelValue: _ctx.searchObject.maxprice,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.searchObject.maxprice) = $event)),
                  name: "maxprice",
                  options: _ctx.searchOptions.price,
                  onChange: _ctx.updateCount,
                  label: "Max Price"
                }, null, 8 /* PROPS */, ["modelValue", "options", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                (_ctx.invalidPriceRange)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, " Oops make sure you have a max price higher than the min price "))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createCommentVNode("suppress ALL ")
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true),
      (_ctx.searchObject.pricetype === 'finance')
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_drop_down, {
                modelValue: _ctx.searchObject.minmonthly,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.searchObject.minmonthly) = $event)),
                name: "minmonthly",
                options: _ctx.searchOptions.monthlyPrice,
                onChange: _ctx.updateCount,
                label: "Min Monthly"
              }, null, 8 /* PROPS */, ["modelValue", "options", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_drop_down, {
                modelValue: _ctx.searchObject.maxmonthly,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.searchObject.maxmonthly) = $event)),
                name: "maxmonthly",
                options: _ctx.searchOptions.monthlyPrice,
                onChange: _ctx.updateCount,
                label: "Max Monthly"
              }, null, 8 /* PROPS */, ["modelValue", "options", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_24, [
              (_ctx.invalidPriceRange)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, " Oops make sure you have a max monthly price higher than the min monthly price "))
                : _createCommentVNode("v-if", true)
            ])
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.cars === 'used')
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _cache[40] || (_cache[40] = _createElementVNode("div", { class: "refine__header" }, " Location ", -1 /* CACHED */)),
              (_ctx.searchObject.city || _ctx.searchObject.region)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("i", {
                        class: "fi-cancel text-red pointer",
                        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.removeRegionFilter && _ctx.removeRegionFilter(...args)))
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.localFilterLabel), 1 /* TEXT */)
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_component_input_text, {
                "input-type": "text",
                name: "postcode",
                css: "text--uppercase",
                modelValue: _ctx.searchObject.postcode,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.searchObject.postcode) = $event)),
                label: "Postcode",
                placeholder: "E.g. M3 5ER",
                "no-float": true,
                onUpdate: _ctx.postcodeInput
              }, null, 8 /* PROPS */, ["modelValue", "onUpdate"])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_drop_down, {
                modelValue: _ctx.searchObject.range,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.searchObject.range) = $event)),
                name: "range",
                options: _ctx.searchOptions.range,
                onChange: _ctx.updateCount,
                label: "Range"
              }, null, 8 /* PROPS */, ["modelValue", "options", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_32, [
              (_ctx.invalidPostcode)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, " Oops this does not look like a valid postcode. "))
                : _createCommentVNode("v-if", true),
              (_ctx.postcodeRequired)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, " Please enter a postcode to sort by distance "))
                : _createCommentVNode("v-if", true)
            ])
          ]))
        : _createCommentVNode("v-if", true),
      (['used', 'finance'].includes(_ctx.cars))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
            _cache[42] || (_cache[42] = _createElementVNode("div", { class: "refine__header" }, " Mileage ", -1 /* CACHED */)),
            _createVNode(_component_drop_down, {
              modelValue: _ctx.searchObject.maxmileage,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.searchObject.maxmileage) = $event)),
              name: "maxmileage",
              options: _ctx.searchOptions.maxmileage,
              onChange: _ctx.updateCount
            }, null, 8 /* PROPS */, ["modelValue", "options", "onChange"]),
            (_ctx.hasYearRange)
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _cache[41] || (_cache[41] = _createElementVNode("div", { class: "col-12-sm" }, [
                    _createElementVNode("div", { class: "refine__header" }, " Production Year ")
                  ], -1 /* CACHED */)),
                  _createElementVNode("div", _hoisted_36, [
                    _createVNode(_component_input_text, {
                      modelValue: _ctx.searchObject.minyear,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.searchObject.minyear) = $event)),
                      "input-type": "number",
                      name: "minyear",
                      onUpdate: _ctx.updateCount,
                      label: "From"
                    }, null, 8 /* PROPS */, ["modelValue", "onUpdate"])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createVNode(_component_input_text, {
                      modelValue: _ctx.searchObject.maxyear,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.searchObject.maxyear) = $event)),
                      "input-type": "number",
                      name: "maxyear",
                      onUpdate: _ctx.updateCount,
                      label: "To"
                    }, null, 8 /* PROPS */, ["modelValue", "onUpdate"])
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    (_ctx.invalidYearRange)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, " Oops, make sure the max year is higher than the min year "))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            (!_ctx.hasYearRange)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, " Age "))
              : _createCommentVNode("v-if", true),
            (!_ctx.hasYearRange)
              ? (_openBlock(), _createBlock(_component_drop_down, {
                  key: 2,
                  modelValue: _ctx.searchObject.maxage,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.searchObject.maxage) = $event)),
                  name: "maxage",
                  options: _ctx.searchOptions.maxage,
                  onChange: _ctx.updateCount
                }, null, 8 /* PROPS */, ["modelValue", "options", "onChange"]))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("div", _hoisted_42, [
          _createVNode(_component_slider, {
            name: "ulezexempt",
            modelValue: _ctx.searchObject.ulezexempt,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.searchObject.ulezexempt) = $event)),
            onChange: _ctx.updateCount,
            "on-text": "Yes",
            "off-text": ""
          }, null, 8 /* PROPS */, ["modelValue", "onChange"])
        ]),
        _cache[43] || (_cache[43] = _createElementVNode("div", { style: {"margin-left":"10px"} }, " ULEZ Exempt ", -1 /* CACHED */))
      ]),
      (!_ctx.callCenterUser)
        ? (_openBlock(), _createElementBlock("a", {
            key: 7,
            href: "#",
            class: "d-block text-center text--underline mb-10",
            onClick: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showMoreOptions && _ctx.showMoreOptions(...args)), ["prevent"])),
            innerHTML: _ctx.moreOptionsVisible ? 'Less Options' : 'More Options'
          }, null, 8 /* PROPS */, _hoisted_43))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", {
        class: _normalizeClass({'refine__extras': true, hidden: !_ctx.callCenterUser && !_ctx.moreOptionsVisible})
      }, [
        _withDirectives(_createElementVNode("div", null, [
          _cache[44] || (_cache[44] = _createElementVNode("div", { class: "refine__header" }, " Colour ", -1 /* CACHED */)),
          _createVNode(_component_drop_down, {
            modelValue: _ctx.searchObject.colour,
            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.searchObject.colour) = $event)),
            name: "colour",
            options: _ctx.searchOptions.colour,
            onChange: _ctx.updateCount
          }, null, 8 /* PROPS */, ["modelValue", "options", "onChange"])
        ], 512 /* NEED_PATCH */), [
          [_vShow, _ctx.cars === 'used']
        ]),
        _cache[49] || (_cache[49] = _createElementVNode("div", { class: "refine__header" }, " Transmission ", -1 /* CACHED */)),
        _createVNode(_component_drop_down, {
          modelValue: _ctx.searchObject.transmission,
          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.searchObject.transmission) = $event)),
          name: "transmission",
          options: _ctx.searchOptions.transmission,
          onChange: _ctx.updateCount
        }, null, 8 /* PROPS */, ["modelValue", "options", "onChange"]),
        _cache[50] || (_cache[50] = _createElementVNode("div", { class: "refine__header" }, " Engine Size ", -1 /* CACHED */)),
        _createVNode(_component_drop_down, {
          modelValue: _ctx.searchObject.litre,
          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.searchObject.litre) = $event)),
          name: "litre",
          options: _ctx.searchOptions.litre,
          onChange: _ctx.updateCount
        }, null, 8 /* PROPS */, ["modelValue", "options", "onChange"]),
        _cache[51] || (_cache[51] = _createElementVNode("div", { class: "refine__header" }, " MPG ", -1 /* CACHED */)),
        _createVNode(_component_drop_down, {
          modelValue: _ctx.searchObject.mpg,
          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.searchObject.mpg) = $event)),
          name: "mpg",
          options: _ctx.searchOptions.mpg,
          onChange: _ctx.updateCount
        }, null, 8 /* PROPS */, ["modelValue", "options", "onChange"]),
        _cache[52] || (_cache[52] = _createElementVNode("div", { class: "refine__header" }, " Seats ", -1 /* CACHED */)),
        _createVNode(_component_drop_down, {
          modelValue: _ctx.searchObject.seats,
          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.searchObject.seats) = $event)),
          name: "seats",
          options: _ctx.searchOptions.seats,
          onChange: _ctx.updateCount
        }, null, 8 /* PROPS */, ["modelValue", "options", "onChange"]),
        _cache[53] || (_cache[53] = _createElementVNode("div", { class: "refine__header" }, " Doors ", -1 /* CACHED */)),
        _createVNode(_component_drop_down, {
          modelValue: _ctx.searchObject.doors,
          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.searchObject.doors) = $event)),
          name: "doors",
          options: _ctx.searchOptions.doors,
          onChange: _ctx.updateCount
        }, null, 8 /* PROPS */, ["modelValue", "options", "onChange"]),
        _cache[54] || (_cache[54] = _createElementVNode("div", { class: "refine__header" }, " Fuel Type ", -1 /* CACHED */)),
        _createVNode(_component_drop_down, {
          modelValue: _ctx.searchObject.fuel,
          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.searchObject.fuel) = $event)),
          name: "fuel",
          options: _ctx.searchOptions.fuel,
          onChange: _ctx.updateCount
        }, null, 8 /* PROPS */, ["modelValue", "options", "onChange"]),
        _withDirectives(_createElementVNode("div", null, [
          _cache[45] || (_cache[45] = _createElementVNode("div", { class: "refine__header" }, " Wheelbase ", -1 /* CACHED */)),
          _createVNode(_component_drop_down, {
            modelValue: _ctx.searchObject.wheelbase,
            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.searchObject.wheelbase) = $event)),
            name: "fuel",
            options: _ctx.searchOptions.wheelbase,
            onChange: _ctx.updateCount
          }, null, 8 /* PROPS */, ["modelValue", "options", "onChange"])
        ], 512 /* NEED_PATCH */), [
          [_vShow, _ctx.cars === 'used']
        ]),
        _createElementVNode("div", _hoisted_44, [
          _cache[46] || (_cache[46] = _createElementVNode("div", { class: "col-12-sm" }, [
            _createElementVNode("div", { class: "refine__header" }, " Insurance group ")
          ], -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_45, [
            _createVNode(_component_drop_down, {
              modelValue: _ctx.searchObject.mininsurance,
              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.searchObject.mininsurance) = $event)),
              name: "mininsurance",
              options: _ctx.searchOptions.insurance,
              onChange: _ctx.updateCount,
              label: "Minimum"
            }, null, 8 /* PROPS */, ["modelValue", "options", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createVNode(_component_drop_down, {
              modelValue: _ctx.searchObject.maxinsurance,
              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.searchObject.maxinsurance) = $event)),
              name: "maxinsurance",
              options: _ctx.searchOptions.insurance,
              onChange: _ctx.updateCount,
              label: "Maximum"
            }, null, 8 /* PROPS */, ["modelValue", "options", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_47, [
            (_ctx.invalidInsuranceGroupRange)
              ? (_openBlock(), _createElementBlock("div", _hoisted_48, " Oops make sure you have a max insurance group higher than the min insurance group "))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        (_ctx.cars === 'used')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createVNode(_component_slider, {
                    name: "reserveonline",
                    modelValue: _ctx.searchObject.reserveonline,
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.searchObject.reserveonline) = $event)),
                    onChange: _ctx.updateCount,
                    "on-text": "Yes",
                    "off-text": "No"
                  }, null, 8 /* PROPS */, ["modelValue", "onChange"])
                ]),
                _cache[47] || (_cache[47] = _createElementVNode("div", { style: {"margin-left":"10px"} }, " Can reserve online ", -1 /* CACHED */))
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createVNode(_component_slider, {
                    name: "independent",
                    modelValue: _ctx.searchObject.independent,
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.searchObject.independent) = $event)),
                    onChange: _ctx.updateCount,
                    "on-text": "Yes",
                    "off-text": "No"
                  }, null, 8 /* PROPS */, ["modelValue", "onChange"])
                ]),
                _cache[48] || (_cache[48] = _createElementVNode("div", { style: {"margin-left":"10px"} }, " Independent dealers only ", -1 /* CACHED */))
              ])
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        _cache[55] || (_cache[55] = _createElementVNode("div", { class: "refine__header" }, " Keyword ", -1 /* CACHED */)),
        _createVNode(_component_keywords, {
          keywords: _ctx.searchObject.keywords,
          "use-get-vars": true,
          onUpdate: _ctx.updateKeywords
        }, null, 8 /* PROPS */, ["keywords", "onUpdate"])
      ], 2 /* CLASS */),
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("button", {
            onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.searchResults && _ctx.searchResults(...args))),
            type: "button",
            class: "button button--full button--small mb-10",
            disabled: _ctx.resultUpdating || _ctx.resultCount === 0
          }, [
            (!_ctx.resultUpdating)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" See " + _toDisplayString(_ctx.formatThousandsWithRounding(_ctx.resultCount)) + " results ", 1 /* TEXT */),
                  _cache[56] || (_cache[56] = _createElementVNode("i", { class: "fi-right-open" }, null, -1 /* CACHED */))
                ], 64 /* STABLE_FRAGMENT */))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _cache[57] || (_cache[57] = _createElementVNode("i", {
                    class: "fi-spinner",
                    style: {"margin-right":"10px"}
                  }, null, -1 /* CACHED */)),
                  _cache[58] || (_cache[58] = _createTextVNode(" Searching vehicles... ", -1 /* CACHED */))
                ], 64 /* STABLE_FRAGMENT */))
          ], 8 /* PROPS */, _hoisted_55)
        ]),
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("button", {
            onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.saveSearch && _ctx.saveSearch(...args))),
            type: "button",
            class: "button button--full button--small mb-10"
          }, " Save search ")
        ]),
        _createElementVNode("div", _hoisted_57, [
          _createElementVNode("button", {
            onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.clearOptions($event))),
            type: "button",
            class: "button button--ghost button--full button--small mb-10"
          }, " Reset filters ")
        ]),
        _cache[60] || (_cache[60] = _createElementVNode("div", { class: "col-12-sm text-center" }, [
          _createElementVNode("a", { href: "/garage#savedSearches" }, "View saved searches"),
          _createTextVNode(" | "),
          _createElementVNode("a", { href: "/garage/starred-vehicles" }, "View saved vehicles")
        ], -1 /* CACHED */)),
        (_ctx.mobileRefineOpened)
          ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
              _createElementVNode("button", {
                onClick: _cache[35] || (_cache[35] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.mobileRefineToggle && _ctx.mobileRefineToggle(...args)), ["prevent"])),
                type: "button",
                class: "button button--ghost button--full button--small mb-10"
              }, [...(_cache[59] || (_cache[59] = [
                _createElementVNode("i", { class: "fi-filter" }, null, -1 /* CACHED */),
                _createTextVNode(" Close ", -1 /* CACHED */)
              ]))])
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ], 2 /* CLASS */)
  ]))
}